import './Button.css'

export default function ImageButton(props) {
    return (
        <button style = {{maxWidth: 'max-content', height: '42px', justifyContent: 'center', marginRight: '10px'}} className = "ImageButton" onClick = {props.onClick}>
            <img src = {props.img} style = {{width: props.width, transform:`translateY(-${props.marginBottom})`}}/>
        </button>
    )
}